<script setup lang="ts">
import { odsNavigation, odsNavigationItem } from 'omind-design-system/components/odsNavigation';
import { useDataStore } from '@/domains/-data/stores/useDataStore.ts';

const dataStore = useDataStore();
</script>

<template>
  <odsNavigation>
    <odsNavigationItem
      v-if="!dataStore.isResources"
      :icon="'space_dashboard'"
      :label="$t('navigation.dashboard')"
      :to="{ name: 'dashboard' }"
    />
    <!--<odsNavigationItem
            v-if="!dataStore.isResources"
            :icon="'group'"
            :label="$t('navigation.internal')"
            :disabled="true"
            :to="{name: 'internal'}"
        />
        -->
    <odsNavigationItem
      v-if="dataStore.isAI"
      :icon="'stars'"
      :label="$t('navigation.ai_adoption')"
      :to="{ name: 'ai_adoption' }"
    />
    <odsNavigationItem
      :icon="'analytics'"
      :label="$t('navigation.resources')"
      :to="{ name: 'resources' }"
    />
    
    <!-- <odsNavigationItem
            :icon="'build'"
            :label="$t('navigation.tools')"
            :disabled="true"
            :to="{name: 'home'}"
        />
        -->
    <!-- <div class="separator"></div>
        <odsNavigationItem
            :icon="'handshake'"
            :label="$t('navigation.community')"
            :group="true"
        >
            <odsNavigationItem
                :label="$t('navigation.community_events')"
                :to="getEventsRouteLocation(SESSION.wsp?.workspace.id!) as object"
            />
            <odsNavigationItem
                :label="$t('navigation.community_news')"
                :to="getEventsRouteLocation(SESSION.wsp?.workspace.id!,'#news') as object"
            />
            <odsNavigationItem
                :label="$t('navigation.community_resources')"
                :to="getResourcesRouteLocation(SESSION.wsp?.workspace.id!) as object"
            />
            <odsNavigationItem
                :label="$t('navigation.community_glossary')"
                :to="getGlossaryRouteLocation(SESSION.wsp?.workspace.id!) as object"
            />
        </odsNavigationItem> -->

    <!-- <odsNavigationItem
            :icon="'handshake'"
            :label="$t('navigation.community')"
            :to="getCommunityRouteLocation(SESSION.wsp?.workspace.id!) as object"
        /> -->
    <!-- <odsNavigationItem
            :icon="'contacts'"
            :label="$t('navigation.glossary')"
            :to="getGlossaryRouteLocation(SESSION.wsp?.workspace.id!) as object"
        /> -->
  </odsNavigation>
</template>

<style lang="scss">
.ods-navigation {
  .separator {
    width: 100%;
    height: 0.0625rem;
    opacity: 0.2;
    background: var(--color-neutral-10);
  }
}
</style>
